module.exports = __webpack_public_path__ + "15e089c44a00d3407fd640492caf6976.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/referral/warning.svg
// module id = 1044
// module chunks = 0